<template>
  <div class="landingSection1">
    <landing-container />
  </div>
</template>

<script>
import LandingContainer from "@/components/Landing/components/LandingContainer";

export default {
  name: "LandingSection1",
  components: { LandingContainer },
};
</script>

<style lang="scss" scoped>
.landingSection1 {
  background: url("~img/landing/bg.png") center no-repeat;
  background-size: cover;

  height: 280px;

  @media (min-width: $breakpoint-md) {
    background-image: url("~img/landing/bg-md.png");
    height: 370px;
  }

  @media (min-width: $breakpoint-xl) {
    background-image: url("~img/landing/bg-xl.png");
  }
}
</style>
